export default function chooseSeason(season) {
    switch (season) {
        case 'Letní':
            return '<img src="/assets/img/icons/sun.svg" alt="Ikona sezóny">'
        case 'Zimní':
            return '<img src="/assets/img/icons/snowflake.svg" alt="Ikona sezóny">'
        case 'Celoroční':
            return '<img src="/assets/img/icons/wholeyear.svg" alt="Ikona sezóny">'
        default:
            return ''
    }
}